// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interndashboard-inline-1 {
  margin-top: 16px;
}

.interndashboard-inline-2 {
  text-align: center;
  color: #94a3b8;
  padding: 20px;
  font-size: 13px;
}

.interndashboard-inline-3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.interndashboard-inline-4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
}

.interndashboard-inline-5 {
  font-weight: 600;
  font-size: 13px;
}

.interndashboard-inline-6 {
  font-size: 11px;
  color: #64748b;
}

.interndashboard-inline-7 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.interndashboard-inline-8,
.interndashboard-inline-9,
.interndashboard-inline-10,
.interndashboard-inline-11,
.interndashboard-inline-12,
.interndashboard-inline-13,
.interndashboard-inline-14 {
  width: 100%;
  max-width: none;
}

.interndashboard-dyn-1 {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  background: var(--interndashboard-1-background);
  color: var(--interndashboard-1-color);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/InternDashboard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;;;EAOE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;EAC/C,qCAAqC;EACrC,gBAAgB;AAClB","sourcesContent":[".interndashboard-inline-1 {\n  margin-top: 16px;\n}\n\n.interndashboard-inline-2 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 20px;\n  font-size: 13px;\n}\n\n.interndashboard-inline-3 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.interndashboard-inline-4 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  border-radius: 8px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n}\n\n.interndashboard-inline-5 {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.interndashboard-inline-6 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.interndashboard-inline-7 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.interndashboard-inline-8,\n.interndashboard-inline-9,\n.interndashboard-inline-10,\n.interndashboard-inline-11,\n.interndashboard-inline-12,\n.interndashboard-inline-13,\n.interndashboard-inline-14 {\n  width: 100%;\n  max-width: none;\n}\n\n.interndashboard-dyn-1 {\n  font-size: 10px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: var(--interndashboard-1-background);\n  color: var(--interndashboard-1-color);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
